"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridItem = exports.StyledGridItem = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var react_1 = __importDefault(require("react"));
var responsive_1 = require("../../utils/responsive");
var Grid_1 = require("./Grid");
exports.StyledGridItem = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_a) {
    var base = _a.base;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "], ["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "])), (base / Grid_1.GRID_COLUMNS) * 100, (base / Grid_1.GRID_COLUMNS) * 100);
}, function (_a) {
    var sm = _a.sm;
    return (0, responsive_1.small)((0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "], ["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "])), (sm / Grid_1.GRID_COLUMNS) * 100, (sm / Grid_1.GRID_COLUMNS) * 100));
}, function (_a) {
    var md = _a.md;
    return (0, responsive_1.medium)((0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "], ["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "])), (md / Grid_1.GRID_COLUMNS) * 100, (md / Grid_1.GRID_COLUMNS) * 100));
}, function (_a) {
    var lg = _a.lg;
    return (0, responsive_1.large)((0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "], ["\n      max-width: ", "%;\n      flex-basis: ", "%;\n    "])), (lg / Grid_1.GRID_COLUMNS) * 100, (lg / Grid_1.GRID_COLUMNS) * 100));
});
/**
 * A grid item which should always be rendered within a `Grid`.
 *
 * `GridItem`s are used to set the number of columns within the grid which their contents should span.
 *
 * The column widths supplied should be integer values between 1 and 12. A value given to a breakpoint will apply to all the other breakpoints wider than it
 * unless overridden.
 *
 * If no values are supplied, the `GridItem` will span all 12 columns of the grid.
 */
var GridItem = function (_a) {
    var _b = _a.base, base = _b === void 0 ? Grid_1.GRID_COLUMNS : _b, _c = _a.sm, sm = _c === void 0 ? base : _c, _d = _a.md, md = _d === void 0 ? sm : _d, _e = _a.lg, lg = _e === void 0 ? md : _e, children = _a.children, className = _a.className;
    return (react_1.default.createElement(exports.StyledGridItem, { base: base, sm: sm, md: md, lg: lg, className: className }, children));
};
exports.GridItem = GridItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
